import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IconButton } from "@mui/material";

import Page from "../../layout/Page";
import { DataTable } from "../../components/DataTable";
import ListPageActions from "../../components/ListPageActions";
import DownloadButton from "../../components/DownloadButton";
import SwitchCell from "../../components/SwitchCell";
import CustButton from "../../ui/CustButton";
import { YesNoTypeOptions } from "../../components/YesNoTypeOptions";
import DialogConfirm from "../../components/DialogConfirm";
import usePaginationV2 from "../../util/usePaginationV2";
import FilterOptionEnum from "../../enum/FilterOptionEnum";
import MenuListAction from "../../components/MenuListAction";
import { Add, Edit, Delete, Settings } from "@mui/icons-material";
import TenantBatchOperationCrudDialog from "./TenantBatchOperationCrudDialog";
import TenantBatchOperationservice from "../../service/MasterServices/TenantBatchOperationService";
import StatusIcon from "./HangfireStatus";
import NoteDialog from "../../components/NoteDialog";
import OperationType from "../../enum/OperationType";
import DynamicOptions from "../../components/DynamicOptions";
import useGlobal from "../../util/Global";
import { useSelector } from "react-redux";

const TenantBatchOperationPage = ({ title }) => {
    const { t } = useGlobal();
    const [deleteItem, setDeleteItem] = useState(null);
    const [loading, setLoading] = useState(false); // Loading state for action handling
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [logOperation, setLogOperation] = useState(true);
    const [logTitle, setLogTitle] = useState(true);
    const [crudTip, setCrudTip] = useState("");

    const { user } = useSelector(state => state.auth);



    // Switch change handler
    const handelaktifSwitchChange = async (item, newCheckedVal) => {
        console.log(item, newCheckedVal);
        let result = await TenantBatchOperationservice.update({
            id: item.id,
            aktif: !item.aktif
        });
        mainDataList.search();
        return true;
    };

    // Switch change handler
    const handelisEmailTestSwitchChange = async (item, newCheckedVal) => {
        console.log(item, newCheckedVal);
        let result = await TenantBatchOperationservice.update({
            id: item.id,
            isEmailTest: !item.isEmailTest
        });
        mainDataList.search();
        return true;
    };

    const daysOfWeeklist = [
        { key: 'Pazartesi', value: 1 },  // Monday
        { key: 'Salı', value: 2 },       // Tuesday
        { key: 'Çarşamba', value: 3 },   // Wednesday
        { key: 'Perşembe', value: 4 },   // Thursday
        { key: 'Cuma', value: 5 },       // Friday
        { key: 'Cumartesi', value: 6 },  // Saturday
        { key: 'Pazar', value: 7 }       // Sunday
    ];


    function getDaysFromString(inputString) {
        if (!inputString) {
            return ''; // Return an empty string if inputString is null, undefined, or empty
        }
        // Split the input string by commas, convert to numbers, and map to day names
        return inputString.split(',')
            .map(day => {
                const dayNumber = parseInt(day, 10);  // Convert to number
                const dayObject = daysOfWeeklist.find(item => item.value === dayNumber);
                return dayObject ? dayObject.key + ", " : null;  // Return the key or null
            })
            .filter(day => day !== null);  // Remove null values
    }

    // Handle delete actions
    const handleDeleteAction = async () => {
        if (!deleteItem) return;

        setLoading(true);  // Start loading
        try {
            const result = await TenantBatchOperationservice.delete(deleteItem.id);

            if (result) {
                mainDataList.search();  // Refresh data after success
            }
        } catch (error) {
            console.error("Action failed:", error); // Handle any error that occurs during the action
            // Optionally, display an error notification or message
        } finally {
            setLoading(false);  // End loading regardless of success or failure
            setOpenDialog(false);  // Close the confirm dialog
        }
    };



    const handleOpenDialog = () => {
        setDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
    };


    // Column definitions
    const columns = [
        {
            passItem: true,
            searchable: false,
            sortable: false,
            label: t('col.islemler'),
            execute: (item) => <MenuListAction menuItems={
                [
                    {
                        label: t('col.trigger'),
                        icon: <Settings fontSize="small" style={{ color: '#DDD4FF' }} />,
                        action: async () => {
                            await TenantBatchOperationservice.TriggerTask({ id: item.id });
                            mainDataList.search([]);
                        }
                    },
                    {
                        label: t('col.showLog'),
                        icon: <Settings fontSize="small" style={{ color: '#DDD4FF' }} />,
                        action: async () => {
                            var result = await TenantBatchOperationservice.LogOperation({ id: item.id });
                            if (result.isSuccess) {
                                setLogOperation(result.message);
                                setLogTitle(result.resultObject);
                                handleOpenDialog();
                            }
                        }
                    },
                    {
                        label: t('col.Reset'),
                        icon: <Settings fontSize="small" style={{ color: '#DDD4FF' }} />,
                        action: async () => {
                            await TenantBatchOperationservice.ResetOperation({ id: item.id });
                            mainDataList.search([]);
                        }
                    },
                ]
            } />
        },
        {
            name: "operationId",
            label: t('col.operationId'),
            textAlign: "center",

        },

        user.isMaster == true ? {
            name: "tenantName",
            label: t('col.tenantName'),
            textAlign: "left",
            searchable: true,
            selectOptions: <DynamicOptions serviceType="Tenant" />,
            searchType: 'select',
            searchField: "tenantId",
            orderByField: "tenantName",
        } : {
            name: "tenantName",
            label: t('col.tenantName'),
            textAlign: "left",
            searchable: false,
        },
        ,
        {
            name: "operationName",
            label: t('col.operationName'),
            textAlign: "left",
            selectOptions: <DynamicOptions serviceType="BatchOperation" />,
            searchType: 'select',
            searchField: "operationId",
            orderByField: "operationName",
        },
        {
            name: "operationType",
            label: t('col.operationType'),
            textAlign: "center",
            execute: (item) => OperationType[item],
            searchable: true,
            searchType: "select",
            selectOptions: <FilterOptionEnum enumObject={OperationType} />
        },
        {
            name: "interval",
            label: t('col.interval'),
            textAlign: "center",
        },
        {
            name: "specificTime",
            label: t('col.specificTime'),
            textAlign: "center",
        },
        {
            name: "daysOfWeek",
            label: t('col.daysOfWeek'),
            textAlign: "left",
            execute: (item) => getDaysFromString(item)
        },
        {
            name: "daysOfMonth",
            label: t('col.daysOfMonth'),
            textAlign: "left",
        },
        {
            name: "processStatus",
            label: t('col.processStatus'),
            textAlign: "center",
            execute: (item) => StatusIcon({ status: item })
        },
        {
            name: "aktif",
            type: Boolean,
            label: t('col.aktif'),
            textAlign: "center",
            passItem: true,
            searchable: true,
            searchType: "select",
            selectOptions: <YesNoTypeOptions />,
            execute: (item) =>
                <SwitchCell item={item}
                    checked={item.aktif}
                    onClick={(newCheckedVal) => handelaktifSwitchChange(item, newCheckedVal)}
                />
        },
        {
            name: "isEmailTest",
            type: Boolean,
            label: t('col.isEmailTest'),
            textAlign: "center",
            passItem: true,
            searchable: true,
            searchType: "select",
            selectOptions: <YesNoTypeOptions />,
            execute: (item) =>
                <SwitchCell item={item}
                    checked={item.isEmailTest}
                    onClick={(newCheckedVal) => handelisEmailTestSwitchChange(item, newCheckedVal)}
                />
        },
        {
            sortable: false,
            searchable: false,
            passItem: true,
            textAlign: "Center",
            title: "action",
            execute: (item) => (
                <>
                    <IconButton
                        onClick={() => handleOpenCrudDialog(item, "Update")}
                        color="warning"
                        variant="contained"
                        title={t("rowActions.update")}
                        size="small">
                        <Edit />
                    </IconButton>
                    <IconButton
                        onClick={() => openConfirmDialog(item)}
                        color="error"
                        variant="contained"
                        title={t("rowActions.delete")}
                        size="small">
                        <Delete />
                    </IconButton>
                </>
            ),
        },



    ];

    // Pagination configuration
    const mainDataList = usePaginationV2({
        service: TenantBatchOperationservice,
        defaultSearchData: { isMaster: user.isMaster },
        pageColumns: columns,
        defaultOrderBy: { name: "tenantId", type: "Desc" },
    });

    // Handle Crud dialog open/close
    ///**********************/////


    const [crudItem, setCrudItem] = useState(null);
    const [onCrudDialogOpen, setCrudDialogOpen] = useState(false);

    const handleOpenCrudDialog = (data, tip) => {
        setCrudItem(data);  // Set the data to pass to the dialog
        setCrudDialogOpen(true);
        setCrudTip(tip);
    };

    const handleTenantBatchOperationClose = async () => {
        setCrudDialogOpen(false);
        await mainDataList.search([]); // Clear the dialog data when closing
    };

    // Handle confirm dialog open/close
    const openConfirmDialog = (item) => {
        // setActionType(item);
        setDeleteItem(item);
        setOpenDialog(true);
    };



    const closeConfirmDialog = () => setOpenDialog(false);

    // Action buttons component
    const ActionButtons = () => (
        <ListPageActions
            left={
                <>
                    <CustButton
                        icon={Add}
                        onClick={() => handleOpenCrudDialog(null, "Create")}
                        style={{ marginLeft: 10 }}
                        disabled={loading}  // Disable buttons when loading
                    >
                        {title + " " + t('button.add')}
                    </CustButton>
                </>
            }

        >
            <DownloadButton service={mainDataList} disabled={loading} />
        </ListPageActions>
    );

    return (
        <Page title={title}>
            <ActionButtons />

            <DataTable
                columns={columns}
                {...mainDataList}
                loading={loading}  // Pass loading state to DataTable if applicable
            />

            <ActionButtons />

            < TenantBatchOperationCrudDialog
                open={onCrudDialogOpen}
                onClose={() => handleTenantBatchOperationClose()}
                data={crudItem}
                crudTip={crudTip}
                title={title}

            />

            <DialogConfirm
                open={openDialog}
                title={t('title.confirmDialogTitle')}
                content={t('message.areYouSureAction')}
                onClose={closeConfirmDialog}
                //onConfirm={handleAction}
                onConfirm={handleDeleteAction}
                loading={loading}  // Disable confirm button when loading
            />

            <NoteDialog
                open={dialogOpen}
                onClose={handleCloseDialog}
                message={logTitle}
                title={logOperation}
            />
        </Page>
    );
};

export default TenantBatchOperationPage;
